import { toast } from "sonner";
import { useShallow } from "zustand/react/shallow";
import { RegulifyService } from "../api/RegulifyService";
import { useLoading } from "../context/LoadingContext";
import { useChatStore } from "../store/useChatStore";
import Chat from "./Chat";

const FileQuery = () => {
  const indexedFile = useChatStore(useShallow((state) => state.indexedFile));
  const setIndexedFile = useChatStore((state) => state.setIndexedFile);
  const { setLoading } = useLoading();

  const handleIndexClick = async (event) => {
    const file = document.getElementById("indexFile").files[0];

    if (!file) {
      toast.warning(
        "Please select standard/regulation file before proceeding.",
      );
      return;
    }

    const formData = new FormData();
    formData.append("query_doc_path", file);

    setLoading(true);

    try {
      const response = await RegulifyService.uploadQueryFile(formData);

      if (response?.status != 200) {
        if (response?.status == 400) {
          toast.error(
            "User input Error. Either file size limit of 25MB exceeded or Unsupported file content to process",
          );
        } else {
          throw new Error("Failed to upload document. try again later..");
        }
      }

      setIndexedFile(file.name);
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };

  if (indexedFile.indexed) {
    return <Chat isDocIndexed={true} />;
  }

  return (
    <div className="p-4">
      <div className="form-control w-full max-w-md">
        <label className="label">
          <span className="label-text font-semibold">
            Select standard/regulation Document {indexedFile.name}
          </span>
        </label>
        <input
          type="file"
          accept=".pdf"
          id="indexFile"
          className="file-input file-input-bordered w-full"
        />
        <p className="mt-1 mb-1 text-sm text-gray-500">
          Accepted formats: <span className="font-medium">.pdf</span>
        </p>
      </div>

      <button
        className="btn btn-primary btn-sm"
        data-tip="Click to start query around the uploaded docunment"
        onClick={handleIndexClick}
      >
        Analyze Document
      </button>
      <p className="mt-2 text-sm text-gray-500">
        Processing may take up to 3 minutes.
      </p>
    </div>
  );
};

export default FileQuery;
